import ConnectionModel from '@mm/state/model/ConnectionModel';
import { StoreState } from '@mm/state/store-interfaces';
import { Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

export const KlaviyoListSelect = ({
  selectedConnection,
  onChange,
  className,
}: {
  selectedConnection?: ConnectionModel;
  onChange: (connection: Partial<ConnectionModel>) => void;
  className?: string;
}) => {
  const klaviyoLists = useSelector((state: StoreState) => state.klaviyo.lists);
  const busy = useSelector((state: StoreState) => state.klaviyo.busy);
  const selectedListId = selectedConnection?.data.listId;

  const mappedOptions = klaviyoLists.map(list => ({
    value: list.id,
    label: list.attributes.name,
  }));

  return (
    <Select
      className={className}
      placeholder="Choose"
      loading={busy}
      defaultValue={selectedListId}
      onChange={option => {
        onChange({
          data: {
            listId: option,
            name: klaviyoLists.find(l => l.id === option)?.attributes.name,
          },
        });
      }}
      options={mappedOptions}
    />
  );
};
